type Props = {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  className?: string;
};

export function NavigationChevronRightIcon(props: Props) {
  return (
    <svg
      width="24"
      height="24"
      fill={props.fill ?? 'none'}
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: props.width ?? 24,
        height: props.height ?? 24,
      }}
      className={props.className}
    >
      <path
        d="m3.5 1 5 5M3.5 11l5-5"
        stroke={props.stroke ?? '#FFFFFF'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
